/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const ONBOARD_MINTER = gql`
mutation CreateOnboarding($brandType: IBrandType!, $userEmail: String!, $userGivenName: String!, $platformFee: Float!, $brandTelephone: String, $brandDescription: String, $brandEmail: String, $brandSameAs: String, $brandName: String, $brandAddress: String, $userFamilyName: String) {
  createOnboarding(brandType: $brandType, userEmail: $userEmail, userGivenName: $userGivenName, platform_fee: $platformFee, brandTelephone: $brandTelephone, brandDescription: $brandDescription, brandEmail: $brandEmail, brandSameAs: $brandSameAs, brandName: $brandName, brandAddress: $brandAddress, userFamilyName: $userFamilyName) {
    brandName
  }
}
`;

